module.exports = "/static/assets/d02e782a95bdc8bfb7157ad4b92acceb.png";